export default __webpack_public_path__ + "static/CelejRafał-5f926246d35eb40a8580c0284b8c7556.png";